/* ============================================================
   FOO HUNG CURIOS — Blog "Load More"
   Fetches the next paginated page, extracts its .blog-card
   elements, and appends them to the grid. No deps.
   ============================================================ */
(function () {
  var btn = document.getElementById('blog-loadmore');
  var grid = document.getElementById('blog-grid');
  if (!btn || !grid) return;

  var wrap = btn.closest('.blog-loadmore-wrap');
  var nextPage = parseInt(wrap.getAttribute('data-next-page'), 10);
  var totalPages = parseInt(wrap.getAttribute('data-total-pages'), 10);
  var baseUrl = wrap.getAttribute('data-base-url');

  function buildUrl(page) {
    var url = baseUrl + (baseUrl.indexOf('?') === -1 ? '?' : '&') + 'page=' + page;
    return url;
  }

  function setLoading(on) {
    if (on) {
      btn.classList.add('is-loading');
      btn.setAttribute('disabled', 'disabled');
    } else {
      btn.classList.remove('is-loading');
      btn.removeAttribute('disabled');
    }
  }

  function finish() {
    if (wrap && wrap.parentNode) wrap.parentNode.removeChild(wrap);
  }

  btn.addEventListener('click', function () {
    if (nextPage > totalPages) { finish(); return; }
    setLoading(true);

    fetch(buildUrl(nextPage), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (res) {
        if (!res.ok) throw new Error('Network response was not ok');
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var cards = doc.querySelectorAll('#blog-grid .blog-card');

        if (!cards.length) { finish(); return; }

        cards.forEach(function (card, i) {
          card.style.opacity = '0';
          card.style.transform = 'translateY(12px)';
          card.style.transition = 'opacity 420ms cubic-bezier(0.22,1,0.36,1) ' + (i * 50) + 'ms, transform 420ms cubic-bezier(0.22,1,0.36,1) ' + (i * 50) + 'ms';
          grid.appendChild(card);
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              card.style.opacity = '1';
              card.style.transform = 'translateY(0)';
            });
          });
        });

        nextPage += 1;
        setLoading(false);
        if (nextPage > totalPages) finish();
      })
      .catch(function () {
        setLoading(false);
        /* Fall back: send the user to the real next page. */
        window.location.href = buildUrl(nextPage);
      });
  });
})();